import apiConfig from "Constants/api_config";
import { request } from "Libs/platform";

import type { SetupCatalog } from "Api/types/SetupCatalog";

export type GetSetupCatalogRequestArguments = {
  organizationId: string;
};

export const getSetupCatalogRequest = ({
  organizationId
}: GetSetupCatalogRequestArguments): Promise<SetupCatalog[]> => {
  return request(
    `${apiConfig.api_url}/organizations/${organizationId}/setup/catalog`,
    "GET"
  );
};
